import TextFieldMaterial from '@mui/material/TextField';
import PropTypes from 'prop-types';

const TextField = ({
  error = false,
  fullWidth = true,
  helperText = ' ',
  inputProps = {},
  label,
  margin = 'normal',
  ...other
}) => {
  return (
    <TextFieldMaterial
      error={error}
      fullWidth={fullWidth}
      helperText={helperText}
      inputProps={inputProps}
      label={label}
      margin={margin}
      variant="outlined"
      {...other}
    />
  );
};

TextField.propTypes = {
  error: PropTypes.bool,
  fullWidth: PropTypes.bool,
  helperText: PropTypes.oneOfType([PropTypes.string, PropTypes.number, PropTypes.node]),
  inputProps: PropTypes.shape({}),
  label: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),
  margin: PropTypes.oneOf(['none', 'dense', 'normal']),
};

export default TextField;
